export default {
  methods: {
    useInstallationName(str, installationName) {
      return (str || '').replace(/%\{installationName\}/g, installationName);
    },
  },
};
